// 特别标注目录格式
// path: '/cms', // 规则：目录级别一个斜线代表一个目录，不要在childen外及内跳级。
// name: 'cms', // 规则: 保证唯一，以path目录名去掉斜线更换短横线
// redirect: '/cms/domain-private', // 规则：childen有子目录出现，用于点击目录或面包屑跳转到子项目的首个页面(不能跳第二第三)
// meta: {
//     parent: '/cms', // 规则：如果没有上级目录则是本目录地址path
//     icon: 'el-icon-menu', // 规则：使用elementui的icon，或使用unicode编码使用自建icon
//     title: '内容', // 规则：标题名，不要超过6个字符
//     path: '', // 如果app iframe link存在，则此path为地址
//     isApp: false, // 是否app
//     isIframe: false, // 是否iframe
//     isLink: false, // 是否islink
//     isAffix: false, // 是否固定tab页签
//     isHide: false, // 是否隐藏
//     params: {}, // 是否带参数
// },
// component: () => import('views/layouts/lib/parent'), // 如果是目录则使用parent容器，子项使用对应路径页面/xx/xx/index.vue

export const dynamicRoutes = [
    // {
    //     path: '/xx',
    //     name: '',
    //     redirect: '/xx/xx',
    //     meta: {
    //         parent: '/xx',
    //         icon: 'el-icon-menu',
    //         title: '',
    //         path: '',
    //         isApp: false,
    //         isIframe: false,
    //         isLink: false,
    //         isAffix: false,
    //         isHide: false,
    //         params: {},
    //     },
    //     component: () => import('views/layouts/lib/parent'),
    //     children: [
    //         {
    //             path: '/xx/xx',
    //             name: 'xx-xx',
    //             component: () => import('views/modules/xx/xx/index.vue'),
    //             meta: {
    //                 parent: '/xx',
    //                 icon: 'el-icon-document',
    //                 title: '',
    //                 path: '',
    //                 isApp: false,
    //                 isIframe: false,
    //                 isLink: false,
    //                 isAffix: false,
    //                 isHide: false,
    //                 params: {},
    //             },
    //         },
    //     ],
    // },
    {
        path: '/cms',
        name: 'cms',
        redirect: '/cms/domain-private',
        meta: {
            parent: '/cms',
            icon: 'el-icon-menu',
            title: '内容',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
        component: () => import('views/layouts/lib/parent'),
        children: [
            {
                path: '/cms/domain-private',
                name: 'cms-domain-private',
                component: () => import('views/modules/cms/domain-private/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '私有域名管理',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {}, // 动态菜单的传值填写 params: { is: 1 },
                },
            },
            {
                path: '/cms/column-mange',
                name: 'cms-column-mange',
                component: () => import('views/modules/cms/column-mange/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '栏目管理',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {}, // 动态菜单的传值填写 params: { is: 1 },
                },
            },
            // {
            //     path: '/cms/domain',
            //     name: 'cms-domain',
            //     component: () => import('views/modules/cms/domain/index.vue'),
            //     meta: {
            //         parent: '/cms',
            //         icon: 'el-icon-document',
            //         title: '公共域名管理',
            //         path: '',
            //         isApp: false,
            //         isIframe: false,
            //         isLink: false,
            //         isAffix: false,
            //         isHide: false,
            //         params: {},
            //     },
            // },
            {
                path: '/cms/seo',
                name: 'cms-seo',
                component: () => import('views/modules/cms/seo/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '网页关键词优化',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/seo-tool',
                name: 'cms-seo-tool',
                component: () => import('views/modules/cms/seo-tool/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: 'SEO工具',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/sitestatus',
                name: 'cms-sitestatus',
                component: () => import('views/modules/cms/sitestatus/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '网站状态',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/sitebacks',
                name: 'cms-sitebacks',
                component: () => import('views/modules/cms/sitebacks/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '网站备份',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/privateSitebacks',
                name: 'cms-private/sitebacks',
                component: () => import('views/modules/cms/privateSitebacks/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '私有化网站备份',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/website-set',
                redirect: '/cms/website-set',
                name: 'cms-website-set',
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '系统设置',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
                component: () => import('views/layouts/lib/parent'),
                children: [
                    {
                        path: '/cms/website-set/base-set',
                        name: 'cms-website-set-base-set',
                        component: () => import('@/views/modules/cms/website-set/base-set/index.vue'),
                        meta: {
                            parent: '/cms/website-set',
                            icon: 'el-icon-document',
                            title: '基本设置',
                            path: '',
                            isApp: false,
                            isIframe: false,
                            isLink: false,
                            isAffix: false,
                            isHide: false,
                            params: {},
                        },
                    },
                    {
                        path: '/cms/website-set/sensitive-word-check',
                        name: 'cms-website-set-sensitive-word-check',
                        component: () => import('views/modules/cms/website-set/sensitive-word-check/index.vue'),
                        meta: {
                            parent: '/cms/website-set',
                            icon: 'el-icon-document',
                            title: '敏感词',
                            path: '',
                            isApp: false,
                            isIframe: false,
                            isLink: false,
                            isAffix: false,
                            isHide: false,
                            params: {},
                        },
                    },
                    {
                        path: '/cms/website-set/virtualroot',
                        name: 'cms-website-set-virtualroot',
                        component: () => import('views/modules/cms/website-set/virtualroot/index.vue'),
                        meta: {
                            parent: '/cms/website-set',
                            icon: 'el-icon-document',
                            title: '虚拟根目录',
                            path: '',
                            isApp: false,
                            isIframe: false,
                            isLink: false,
                            isAffix: false,
                            isHide: false,
                            params: {},
                        },
                    },
                    {
                        path: '/cms/website-set/third-party',
                        name: 'cms-website-set-third-party',
                        component: () => import('views/modules/cms/website-set/third-party/index.vue'),
                        meta: {
                            parent: '/cms/website-set',
                            icon: 'el-icon-document',
                            title: '第三方代码',
                            path: '',
                            isApp: false,
                            isIframe: false,
                            isLink: false,
                            isAffix: false,
                            isHide: false,
                            params: {},
                        },
                    },
                ],
            },
            // {
            //     path: '/cms/ssl',
            //     name: 'cms-ssl',
            //     component: () => import('views/modules/cms/ssl/index.vue'),
            //     meta: {
            //         parent: '/cms',
            //         icon: 'el-icon-document',
            //         title: 'SSL证书管理',
            //         path: '',
            //         isApp: false,
            //         isIframe: false,
            //         isLink: false,
            //         isAffix: false,
            //         isHide: false,
            //         params: {},
            //     },
            // },
            {
                path: '/cms/ip-black',
                name: 'cms-ip-black',
                component: () => import('views/modules/cms/ip-black/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: 'IP黑名单',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/banner',
                name: 'cms-banner',
                component: () => import('views/modules/cms/banner/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: 'Banner管理',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/navigation',
                name: 'cms-navigation',
                component: () => import('views/modules/cms/navigation/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '导航管理',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/tag-manage',
                name: 'cms-tag-manage',
                component: () => import('views/modules/cms/tag-manage/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '标签管理',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/content-type',
                name: 'cms-content-type',
                component: () => import('views/modules/cms/content-type/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '内容类型',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/content',
                name: 'cms-content',
                component: () => import('views/modules/cms/content/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '内容管理',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/img-lib',
                name: 'cms-img-lib',
                component: () => import('views/modules/cms/img-lib/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '图片库',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/video-lib',
                name: 'cms-video-lib',
                component: () => import('views/modules/cms/video-lib/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '视频库',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/file-lib',
                name: 'cms-file-lib',
                component: () => import('views/modules/cms/file-lib/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: '文件库',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/cms/seo-analysis',
                name: 'cms-seo-analysis',
                component: () => import('views/modules/cms/seo-analysis/index.vue'),
                meta: {
                    parent: '/cms',
                    icon: 'el-icon-document',
                    title: 'seo分析',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
        ],
    },
    {
        path: '/message',
        name: 'message',
        redirect: '/message/set',
        meta: {
            parent: '/message',
            icon: 'el-icon-menu',
            title: '消息管理',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
        component: () => import('views/layouts/lib/parent'),
        children: [
            {
                path: '/message/set',
                name: 'message-set',
                component: () => import('views/modules/message/set/index.vue'),
                meta: {
                    parent: '/message',
                    icon: 'el-icon-document',
                    title: '消息配置',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/message/sms',
                name: 'message-sms',
                component: () => import('views/modules/message/sms/index.vue'),
                meta: {
                    parent: '/message',
                    icon: 'el-icon-document',
                    title: '短信通道配置',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/message/email',
                name: 'message-email',
                component: () => import('views/modules/message/email/index.vue'),
                meta: {
                    parent: '/message',
                    icon: 'el-icon-document',
                    title: '企业邮箱配置',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/message/stand-msg',
                name: 'message-stand-msg',
                component: () => import('views/modules/message/stand-msg/index.vue'),
                meta: {
                    parent: '/message',
                    icon: 'el-icon-document',
                    title: '站内消息',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/message/preview',
                name: 'message-preview',
                component: () => import('views/modules/message/preview/index.vue'),
                meta: {
                    parent: '/message',
                    icon: 'el-icon-document',
                    title: '预览',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
        ],
    },
    {
        path: '/member',
        name: 'member',
        redirect: '/member/sms',
        meta: {
            parent: '/member',
            icon: 'el-icon-menu',
            title: '会员管理',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
        component: () => import('views/layouts/lib/parent'),
        children: [
            {
                path: '/marketing/sms',
                name: 'marketing-sms',
                component: () => import('views/modules/member/marketing/sms/index'),
                meta: {
                    parent: '/member',
                    icon: 'el-icon-document',
                    title: '短信群发',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/marketing/sms-detail',
                name: 'marketing-sms-detail',
                component: () => import('views/modules/member/marketing/sms-detail/index'),
                meta: {
                    parent: '/member',
                    icon: 'el-icon-document',
                    title: '短信详情',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/marketing/email',
                name: 'marketing-email',
                component: () => import('views/modules/member/marketing/email/index'),
                meta: {
                    parent: '/member',
                    icon: 'el-icon-document',
                    title: '邮件群发',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/marketing/email-detail',
                name: 'marketing-email-detail',
                component: () => import('views/modules/member/marketing/email-detail/index'),
                meta: {
                    parent: '/member',
                    icon: 'el-icon-document',
                    title: '短信详情',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
        ],
    },
    {
        path: '/app',
        name: 'app',
        redirect: '/app/use',
        meta: {
            parent: '/app',
            icon: 'el-icon-menu',
            title: '应用',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
        component: () => import('views/layouts/lib/parent'),
        children: [
            {
                path: '/app/use',
                name: 'app-use',
                component: () => import('views/modules/app/use/index.vue'),
                meta: {
                    parent: '/app',
                    icon: 'el-icon-document',
                    title: '已启用应用',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/app/all',
                name: 'app-all',
                component: () => import('views/modules/app/all/index.vue'),
                meta: {
                    parent: '/app',
                    icon: 'el-icon-document',
                    title: '本站所有应用',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
        ],
    },
    {
        path: '/audit',
        name: 'audit',
        redirect: '/app/link',
        meta: {
            parent: '/audit',
            icon: 'el-icon-menu',
            title: '审核管理',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
        component: () => import('views/layouts/lib/parent'),
        children: [
            {
                path: '/audit/link',
                name: 'audit-link',
                component: () => import('views/modules/audit/link/index.vue'),
                meta: {
                    parent: '/audit',
                    icon: 'el-icon-document',
                    title: '审核关联',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/audit/flow',
                name: 'audit-flow',
                component: () => import('views/modules/audit/flow/index.vue'),
                meta: {
                    parent: '/audit',
                    icon: 'el-icon-document',
                    title: '审核流程',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            // {
            //     path: '/audit/add-node',
            //     name: 'audit-node',
            //     component: () => import('views/modules/audit/node/index.vue'),
            //     meta: {
            //         parent: '/audit',
            //         icon: 'el-icon-document',
            //         title: '审核流程',
            //         path: '',
            //         isApp: false,
            //         isIframe: false,
            //         isLink: false,
            //         isAffix: false,
            //         isHide: true,
            //         params: {},
            //     },
            // },
            {
                path: '/audit/content',
                name: 'audit-content',
                component: () => import('views/modules/audit/content/index.vue'),
                meta: {
                    parent: '/audit',
                    icon: 'el-icon-document',
                    title: '审核内容',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
        ],
    },
    {
        path: '/setting',
        name: 'setting',
        redirect: '/setting/domain',
        meta: {
            parent: '/setting',
            icon: 'el-icon-menu',
            title: '设置',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
        component: () => import('views/layouts/lib/parent'),
        children: [
            {
                path: '/setting/domain',
                name: 'setting-domain',
                component: () => import('views/modules/setting/domain/index.vue'),
                meta: {
                    parent: '/setting',
                    icon: 'el-icon-document',
                    title: '域名管理',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/setting/seo',
                name: 'seo-services-mark',
                component: () => import('views/modules/setting/seo/index.vue'),
                meta: {
                    parent: '/',
                    icon: 'el-icon-document',
                    title: 'seo服务授权',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },

            {
                path: '/setting/ssl',
                name: 'setting-ssl',
                component: () => import('views/modules/setting/ssl/index.vue'),
                meta: {
                    parent: '/setting',
                    icon: 'el-icon-document',
                    title: 'SSL证书',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/setting/role',
                name: 'setting-role',
                component: () => import('views/modules/setting/role/index.vue'),
                meta: {
                    parent: '/setting',
                    icon: 'el-icon-document',
                    title: '权限设置',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/setting/festival',
                component: () => import('views/modules/setting/festival/index.vue'),
                meta: {
                    parent: '/setting',
                    title: '节日',
                },
            },
        ],
    },
    {
        path: '/order',
        name: 'order',
        redirect: '/order/list',
        meta: {
            parent: '/order',
            icon: 'el-icon-menu',
            title: '订单',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
        component: () => import('views/layouts/lib/parent'),
        children: [
            {
                path: '/order/list',
                name: 'order-list',
                component: () => import('views/modules/order/list/index.vue'),
                meta: {
                    parent: '/order',
                    icon: 'el-icon-document',
                    title: '订单目录',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/order/delivery',
                name: 'order-delivery',
                component: () => import('views/modules/order/delivery/index.vue'),
                meta: {
                    parent: '/order',
                    icon: 'el-icon-document',
                    title: '配送方式',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/order/payment',
                name: 'order-payment',
                component: () => import('views/modules/order/payment/index.vue'),
                meta: {
                    parent: '/order',
                    icon: 'el-icon-document',
                    title: '支付设置',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/order/money',
                name: 'order-money',
                component: () => import('views/modules/order/money/index.vue'),
                meta: {
                    parent: '/order',
                    icon: 'el-icon-document',
                    title: '币种设置',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/order/transaction',
                name: 'order-transaction',
                component: () => import('views/modules/order/transaction/index.vue'),
                meta: {
                    parent: '/order',
                    icon: 'el-icon-document',
                    title: '交易设置',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/order/detail',
                name: 'order-detail',
                component: () => import('views/modules/order/detail/index.vue'),
                meta: {
                    parent: '/order',
                    icon: 'el-icon-document',
                    title: '订单详情',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
            {
                path: '/order/add',
                name: 'order-add',
                component: () => import('views/modules/order/add/index.vue'),
                meta: {
                    parent: '/order',
                    icon: 'el-icon-document',
                    title: '添加订单',
                    path: '',
                    isApp: false,
                    isIframe: false,
                    isLink: false,
                    isAffix: false,
                    isHide: false,
                    params: {},
                },
            },
        ],
    },
    // {
    //     path: '/link-element-ui',
    //     name: 'link-element-ui',
    //     component: () => import('views/layouts/lib/parent'),
    //     meta: {
    //         parent: '/link-element-ui',
    //         icon: 'el-icon-link',
    //         title: '外链',
    //         isAffix: false,
    //         isHide: false,
    //         path: '//element.eleme.cn/#/zh-CN/component/installation',
    //         isApp: false,
    //         isIframe: false,
    //         isLink: true,
    //         params: {},
    //     },
    //     children: [],
    // },
    // {
    //     path: '/iframes-baidu',
    //     name: 'iframes-baidu',
    //     component: () => import('views/layouts/lib/parent'),
    //     meta: {
    //         parent: '/iframes-baidu',
    //         icon: 'el-icon-link',
    //         title: 'IFrame',
    //         isAffix: false,
    //         isHide: false,
    //         path: '//www.baidu.com',
    //         isApp: false,
    //         isIframe: true,
    //         isLink: false,
    //         params: {},
    //     },
    //     children: [],
    // },
    // {
    //     path: '/vue-app',
    //     name: 'sub-app1',
    //     component: () => import('views/layouts/lib/parent'),
    //     meta: {
    //         parent: '/sub-app1',
    //         icon: 'el-icon-star-on',
    //         title: 'APP1',
    //         isAffix: false,
    //         isHide: false,
    //         path: '//127.0.0.1:7101',
    //         isApp: true,
    //         isIframe: false,
    //         isLink: false,
    //         params: {},
    //     },
    // },
    // {
    //     path: '/vue-app2',
    //     name: 'sub-app2',
    //     component: () => import('views/layouts/lib/parent'),
    //     meta: {
    //         parent: '/sub-app2',
    //         icon: 'el-icon-star-on',
    //         title: 'APP2',
    //         isAffix: false,
    //         isHide: false,
    //         path: '//localhost:7101/docs',
    //         isApp: true,
    //         isIframe: false,
    //         isLink: false,
    //         params: {},
    //     },
    // },
];
